import PropTypes from 'prop-types';
export const authorPropTypes = {
  /**
   * Picture object with src(string) and alt(string)
   */
  picture: PropTypes.shape({
    src: PropTypes.string,
    alt: PropTypes.string
  }),
  /**
   * Author title
   */
  title: PropTypes.string,
  /**
   * Author name
   */
  name: PropTypes.string.isRequired,
  /**
   * Verified label (a text to be displayed in verified badge)
   */
  verifiedLabel: PropTypes.string,
  /**
   * Additional className (used by tooltip only!)
   */
  classname: PropTypes.string,
  /**
   * Children react node (used by tooltip only!)
   */
  children: PropTypes.node
};